import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { SensorEntity } from './sensor.entity';

export enum SensorSubmissionStatus {
	PROCESSED = 'processed',
	FAILED = 'failed',
	REPROCESSED = 'reprocessed',
}

@Index('sensor_submission_device_id_idx', ['deviceId', 'createdDate'])
@Index('sensor_submission_status_idx', ['status'])
@Index('sensor_submission_sensor_idx', ['sensorId'])
@Index('sensor_submission_created_date_idx', ['createdDate'])
@Entity('sensor_submission')
export class SensorSubmissionEntity extends BaseEntity {
	@Column('int', {
		name: 'fk_sensor__id',
		unsigned: true,
		nullable: true,
	})
	public sensorId!: number | null;

	@Column('varchar', { name: 'device_id', length: 128 })
	public deviceId!: string;

	@Column('json', { name: 'payload' })
	public payload!: Record<string, unknown>;

	@Column('enum', {
		name: 'status',
		enum: SensorSubmissionStatus,
		default: SensorSubmissionStatus.PROCESSED,
	})
	public status!: SensorSubmissionStatus;

	@Column('text', { name: 'error_message', nullable: true })
	public errorMessage!: string | null;

	@ManyToOne(() => SensorEntity)
	@JoinColumn({ name: 'fk_sensor__id' })
	public fkSensor!: SensorEntity;
}
